"use strict";

module.exports = {
  common: {
    error: '#E50000'
  },
  fa: {
    primary: '#EA7125',
    accent: '#0072CF'
  },
  csa: {
    primary: '#41AD49',
    accent: '#EA7125'
  },
  aa: {
    primary: '#0072CF',
    accent: '#EA7125'
  }
};